/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M19.7778 17C21.1676 17.5273 22 18.1987 22 18.9299C22 20.6255 17.5228 22 12 22C6.47715 22 2 20.6255 2 18.9299C2 18.1987 2.83244 17.5273 4.22222 17M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5 8.80006C5 4.80003 8.11111 2 12 2C15.8889 2 19 4.80003 19 8.80006C19 15.0816 13.5556 18 12 18C10.4444 18 5 15.0816 5 8.80006Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 2C8.11111 2 5 4.80003 5 8.80006C5 15.0816 10.4444 18 12 18C13.5556 18 19 15.0816 19 8.80006C19 4.80003 15.8889 2 12 2ZM12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10Z"
				fill="currentColor"
			/>
			<path
				d="M19.7778 17C21.1676 17.5273 22 18.1987 22 18.9299C22 20.6255 17.5228 22 12 22C6.47715 22 2 20.6255 2 18.9299C2 18.1987 2.83244 17.5273 4.22222 17M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8ZM12 18C13.5556 18 19 15.0816 19 8.80006C19 4.80003 15.8889 2 12 2C8.11111 2 5 4.80003 5 8.80006C5 15.0816 10.4444 18 12 18Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C7.73402 1.25 4.25 4.34964 4.25 8.80006C4.25 12.1782 5.72005 14.6634 7.39342 16.2929C8.22711 17.1048 9.11557 17.7093 9.90935 18.114C10.6774 18.5056 11.4356 18.75 12 18.75C12.5644 18.75 13.3226 18.5056 14.0907 18.114C14.8844 17.7093 15.7729 17.1048 16.6066 16.2929C18.2799 14.6634 19.75 12.1782 19.75 8.80006C19.75 4.34964 16.266 1.25 12 1.25ZM14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8ZM4.48827 17.7012C4.87555 17.5543 5.07038 17.1212 4.92345 16.734C4.77651 16.3467 4.34345 16.1518 3.95617 16.2988C3.21925 16.5784 2.57615 16.9151 2.10368 17.3175C1.63512 17.7165 1.25 18.257 1.25 18.9299C1.25 19.7094 1.76246 20.3088 2.34528 20.7319C2.94478 21.167 3.76399 21.5277 4.70881 21.8177C6.60766 22.4007 9.18532 22.75 12 22.75C14.8147 22.75 17.3923 22.4007 19.2912 21.8177C20.236 21.5277 21.0552 21.167 21.6547 20.7319C22.2375 20.3088 22.75 19.7094 22.75 18.9299C22.75 18.257 22.3649 17.7165 21.8963 17.3175C21.4239 16.9151 20.7808 16.5784 20.0438 16.2988C19.6565 16.1518 19.2235 16.3467 19.0766 16.734C18.9296 17.1212 19.1245 17.5543 19.5117 17.7012C20.1646 17.9489 20.6326 18.2115 20.9238 18.4595C21.2189 18.7108 21.25 18.8715 21.25 18.9299C21.25 18.9981 21.2028 19.2064 20.7736 19.5179C20.361 19.8174 19.7158 20.1183 18.8509 20.3838C17.1305 20.912 14.7082 21.25 12 21.25C9.29184 21.25 6.86949 20.912 5.14905 20.3838C4.28423 20.1183 3.63898 19.8174 3.22642 19.5179C2.79718 19.2064 2.75 18.9981 2.75 18.9299C2.75 18.8715 2.7811 18.7108 3.07621 18.4595C3.36741 18.2115 3.83542 17.9489 4.48827 17.7012Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19.7778 17C21.1676 17.5273 22 18.1987 22 18.9299C22 20.6255 17.5228 22 12 22C6.47715 22 2 20.6255 2 18.9299C2 18.1987 2.83244 17.5273 4.22222 17M10 8C10 9.10457 10.8954 10 12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6M17.8852 5C18.5914 6.05829 19 7.35037 19 8.80006C19 15.0816 13.5556 18 12 18C10.4444 18 5 15.0816 5 8.80006C5 4.80003 8.11111 2 12 2C13.076 2 14.0925 2.21436 15 2.6092"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M19.7778 17C21.1676 17.5273 22 18.1987 22 18.9299C22 20.6255 17.5228 22 12 22C6.47715 22 2 20.6255 2 18.9299C2 18.1987 2.83244 17.5273 4.22222 17M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8ZM12 18C13.5556 18 19 15.0816 19 8.80006C19 4.80003 15.8889 2 12 2C8.11111 2 5 4.80003 5 8.80006C5 15.0816 10.4444 18 12 18Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.25 8.80006C4.25 4.34964 7.73402 1.25 12 1.25C16.266 1.25 19.75 4.34964 19.75 8.80006C19.75 12.1782 18.2799 14.6634 16.6066 16.2929C15.7729 17.1048 14.8844 17.7093 14.0907 18.114C13.3226 18.5056 12.5644 18.75 12 18.75C11.4356 18.75 10.6774 18.5056 9.90935 18.114C9.11557 17.7093 8.22711 17.1048 7.39342 16.2929C5.72005 14.6634 4.25 12.1782 4.25 8.80006Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8ZM4.48827 17.7012C4.87555 17.5543 5.07038 17.1212 4.92345 16.7339C4.77651 16.3466 4.34345 16.1518 3.95617 16.2987C3.21925 16.5783 2.57615 16.9151 2.10368 17.3174C1.63512 17.7165 1.25 18.257 1.25 18.9298C1.25 19.7094 1.76246 20.3088 2.34528 20.7318C2.94478 21.167 3.76399 21.5276 4.70881 21.8177C6.60766 22.4007 9.18532 22.75 12 22.75C14.8147 22.75 17.3923 22.4007 19.2912 21.8177C20.236 21.5276 21.0552 21.167 21.6547 20.7318C22.2375 20.3088 22.75 19.7094 22.75 18.9298C22.75 18.257 22.3649 17.7165 21.8963 17.3174C21.4239 16.9151 20.7808 16.5783 20.0438 16.2987C19.6565 16.1518 19.2235 16.3466 19.0766 16.7339C18.9296 17.1212 19.1245 17.5543 19.5117 17.7012C20.1646 17.9489 20.6326 18.2115 20.9238 18.4595C21.2189 18.7108 21.25 18.8715 21.25 18.9298C21.25 18.998 21.2028 19.2063 20.7736 19.5179C20.361 19.8174 19.7158 20.1183 18.8509 20.3838C17.1305 20.912 14.7082 21.25 12 21.25C9.29184 21.25 6.86949 20.912 5.14905 20.3838C4.28423 20.1183 3.63898 19.8174 3.22642 19.5179C2.79718 19.2063 2.75 18.998 2.75 18.9298C2.75 18.8715 2.7811 18.7108 3.07621 18.4595C3.36741 18.2115 3.83542 17.9489 4.48827 17.7012Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
